import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Stack, Tabs, Tab, Button, TabProps } from '@mui/material';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

export const StyledAppBar = styled(AppBar)({
  zIndex: 1,
  height: '100%',
  padding: '0px',
  backgroundColor: 'white',
  borderTopLeftRadius: '0px',
  borderBottomLeftRadius: '0px',
  borderTopRightRadius: '0px',
  borderBottomRightRadius: '0px',
});

export const StyledToolbar = styled(Toolbar)({
  '&&': {
    padding: '0px',
    minHeight: '0px',
    height: '100%',
  },
});

export const StyledNavbarStack = styled(Stack)(({ theme }) => ({
  paddingX: {
    xs: theme.spacing(1),
    sm: theme.spacing(1),
    xl: theme.spacing(10),
    md: theme.spacing(1),
  },
}));

export const StyledTabs = styled(Tabs)({
  height: '100%',
});

export const StyledTab = styled(Tab)<TabProps>({
  fontWeight: '400',
  color: '#000',
  textTransform: 'none',
  opacity: 1,
});

export const StyledAddLessonButton = styled(Button)({
  textAlign: 'center',
  whiteSpace: 'nowrap',
  backgroundColor: '#46D090',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#2e885b',
  },
});

export const StyledLogo = createPrefixedPropsFilteredComponent<{ $marginRight: string }>('img')(({ $marginRight }) => ({
  marginRight: $marginRight,
  width: '60px',
  maxHeight: '80px'
}));

export const StyledUserAvatar = styled('img')({
  width: 40,
  height: 40,
  borderRadius: '50%',
  objectFit: 'cover'
}); 